//billing ->cpi setup
export const initialState = {
  //cpi defaults by country
  countryDefaultData: [],
  isCountryDataFound: false,
  cpiAllVal: null,
  tabVal: 0,
  cpiSetupTabGrid: [],
  cpiSetupTabGridLoading: false,
  cpiTabTotal: 0,
  searchParams: {
    active: 'y',
  },
  cpiAmountLoading: false,
  CpiUpdateResponse: '',
  totalCountDefault: 0,
  removeLoading: false,
  removeResponse: [],
  isLoadExists: false,
  goData: false,
  APIRESPONSECOUNTRY: '',
  countryContinue: '',
  contractNameList: '',
  resetResponse: '',
  resetLoading: false,
  resetAPIResponse: '',
  cpiGetLockdonwResponse: null,
  cpiPutLockdonwResponse: null,
  contractAPIResponse: '',
  cpiDate: null,
  historyData: [],
  isLockDown: '',
  isCpiSetupTabOpen: false,
  showTabs: true,
  go: true,
  noShow: 'no',
  historyRecords: [],
  rowArray: [{}],
  currentPage: 1,
};
